module.exports = __webpack_public_path__ + "img/quesTionIcon.34dc45ff.png";